import { type FC, useState } from "react";
import { Pressable } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import "../../../theme";
import { Text } from "../../Text";
import type { ResultState, SearchResult } from "../types";

export interface SearchResultRowProps {
  readonly result: SearchResult;
  readonly state: ResultState;
  readonly onPress: () => void;
  readonly onHoverIn?: (() => void) | undefined;
}

const SearchResultRow: FC<SearchResultRowProps> = ({ result, state, onPress, onHoverIn }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Pressable
      onPress={onPress}
      onHoverIn={() => {
        setHovered(true);
        onHoverIn?.();
      }}
      onHoverOut={() => setHovered(false)}
      style={[styles.resultRow, (state.focused || hovered) && styles.resultRowFocused]}
    >
      <Text textStyle="sm/regular" color="text" numberOfLines={1}>
        {result.name}
      </Text>
      {result.description !== undefined && (
        <Text textStyle="xs/regular" color="textMuted" numberOfLines={1}>
          {result.description}
        </Text>
      )}
    </Pressable>
  );
};

SearchResultRow.displayName = "SearchResultRow";

export { SearchResultRow };

const styles = StyleSheet.create((theme) => ({
  resultRow: {
    paddingHorizontal: theme.spacing["3xl"],
    paddingVertical: theme.spacing.xl,
  },
  resultRowFocused: {
    backgroundColor: theme.colors.surface2.hover,
  },
}));
